import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { CheckYourEmail } from './models/check-email.interface';

@Component({
  selector: 'idp-check-email',
  templateUrl: './check-email.component.html',
  styleUrls: ['./check-email.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckEmailComponent implements AfterViewInit, OnDestroy {
  @Input() pageData!: CheckYourEmail | undefined | null;
  @Input() callBackFunction!: () => void;
  @Output() nextDisplayView: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeOverlayMessage: EventEmitter<boolean> = new EventEmitter();

  constructor(private elemRef: ElementRef) {}

  submit() {
    this.nextDisplayView.emit(this.pageData?.nextDisplayView?.nextViewName);
  }

  viewSqa() {
    this.nextDisplayView.emit(this.pageData?.nextDisplayView?.nextViewName_sqa);
  }

  ngAfterViewInit(): void {
    if (this.pageData?.skipSqaContent) {
      this.elemRef.nativeElement
        .querySelector('#check_email_section > .sqa-content')
        ?.remove();
    } else {
      this.elemRef.nativeElement
        .querySelector('.click-here')
        ?.addEventListener('click', this.viewSqa.bind(this));
    }
  }

  onClosePopUp(): void {
    this.closeOverlayMessage.emit(false);
  }

  ngOnDestroy(): void {
    this.elemRef.nativeElement
      .querySelector('.click-here')
      ?.removeEventListener('click', this.viewSqa, true);
    this.callBackFunction();
  }
}
